import styled from 'styled-components';
import ThemeHelper from '@themes/theme-helper';

export const Root = styled.div(props => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 5px;
    height: 47px;
    width: 80%;
    border-right: 2px solid ${colours.grey[400]};
    font-weight: 600;
    user-select: none;
  `;
});

export const HeaderLeft = styled.span`
  display: inline-flex;
  justify-content: flex-start;
  padding: 5px;
  width: 120px;
  max-height: 10px;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
`;

export const StudentCountText = styled.span`
  padding-left: 5px;
  width: 100px;
`;

export const SvgWrapper = styled.div`
  path {
    fill: '#1981c4';
  }
`;

export const HeaderRight = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 5px;
  width: 100px;
  font-size: 12px;
  font-weight: 400;
  text-align: right;
`;
